import XLSX from "xlsx-js-style";
import { fmtVal } from "@/utils/nhsoDashboardFormat";

// Export the public dashboard payload as a multi-sheet .xlsx.
// Suppressed values must survive to the file, so cells go through fmtVal ("<5"
// stays "<5"). Numbers are written as real numbers (grouped display is Excel's).
const headerStyle = {
  font: { bold: true, color: { rgb: "FFFFFF" } },
  fill: { fgColor: { rgb: "1668B3" } },
  alignment: { horizontal: "left" },
};

// Keep numbers numeric in the sheet, but "<5" as text.
const cell = v => (typeof v === "number" ? v : fmtVal(v));

function styleHeaderRow(ws) {
  const range = XLSX.utils.decode_range(ws["!ref"]);
  for (let c = range.s.c; c <= range.e.c; c += 1) {
    const ref = XLSX.utils.encode_cell({ r: 0, c });
    if (ws[ref]) ws[ref].s = headerStyle;
  }
}

/**
 * @param {object} payload GET /nhsoPublicDashboard response
 * @param {{period:string, areaType:string, area:string, subitem:string}} filters
 */
export function exportDashboardExcel(payload, filters) {
  const wb = XLSX.utils.book_new();
  const add = (name, rows) => {
    const ws = XLSX.utils.json_to_sheet(rows);
    if (rows.length) styleHeaderRow(ws);
    XLSX.utils.book_append_sheet(wb, ws, name.slice(0, 31));
  };

  add("KPI", [
    { ตัวชี้วัด: "ครั้งที่รับบริการ", ค่า: cell(payload.kpi.visits) },
    { ตัวชี้วัด: "ผู้รับบริการ (ไม่ซ้ำ)", ค่า: cell(payload.kpi.patients) },
    { ตัวชี้วัด: "รายการหัตถการ", ค่า: cell(payload.kpi.items) },
    { ตัวชี้วัด: "ทันตแพทย์ผู้ให้บริการ", ค่า: cell(payload.kpi.dentists) },
    { ตัวชี้วัด: "สาขาที่ให้บริการ", ค่า: cell(payload.kpi.branches) },
    { ตัวชี้วัด: "จังหวัดที่ครอบคลุม", ค่า: cell(payload.kpi.provinces) },
  ]);
  add(
    "พื้นที่",
    payload.areaRanking.map(r => ({ พื้นที่: r.name, ครั้ง: cell(r.visits) }))
  );
  add(
    "แนวโน้มรายเดือน",
    payload.trend.map(r => ({ เดือน: r.month, สิทธิ: r.subitem, ครั้ง: cell(r.visits) }))
  );
  add(
    "ช่วงเวลารับบริการ",
    payload.timeslot.map(r => ({ วัน: r.dow, ชั่วโมง: r.hour, ครั้ง: cell(r.visits) }))
  );
  add(
    "ประเภทการรักษา",
    payload.treatTop.map(r => ({ รายการ: r.name, จำนวน: cell(r.count) }))
  );
  add(
    "กลุ่มโรค",
    payload.diagTop.map(r => ({ รหัส: r.code, จำนวน: cell(r.count) }))
  );
  add(
    "กลุ่มโรคตามอายุ",
    payload.diagAge.map(r => ({ รหัส: r.code, ช่วงอายุ: r.ageBand, จำนวน: cell(r.count) }))
  );
  add(
    "ประชากร",
    payload.demographics.map(r => ({
      ช่วงอายุ: r.ageBand,
      เพศ: r.gender,
      ผู้รับบริการ: cell(r.patients),
    }))
  );
  add(
    "การกลับมาใช้สิทธิ",
    payload.funnel.map(r => ({ ครั้งที่: r.visitNo, จำนวน: cell(r.visits) }))
  );
  add(
    "รายใหม่รายเดิม",
    payload.newReturning.map(r => ({
      เดือน: r.month,
      รายใหม่: cell(r.newPatients),
      รายเดิม: cell(r.returning),
    }))
  );

  const fname = `nhso-dashboard_${filters.period}_${filters.areaType}-${filters.area}.xlsx`;
  XLSX.writeFile(wb, fname);
}

export default exportDashboardExcel;
